import { DateTime } from 'luxon';
import { Configuration, Country } from './configuration';

export namespace ConfigurationParsers {
  export class ConfigurationJson {
    variable!: string;
    value!: string;
    updatedBy!: number;
    updatedAt!: string;
  }

  export function toConfiguration(input: ConfigurationJson): Configuration {
    return {
      variable: input.variable,
      value: input.value,
      updatedBy: input.updatedBy,
      updatedAt: DateTime.fromISO(input.updatedAt, { setZone: true }),
    };
  }

  export class CountryJson {
    id!: number;
    code!: string;
    name!: string;
  }

  export function toCountry(input: CountryJson): Country {
    return {
      id: input.id,
      code: input.code,
      name: input.name,
    };
  }
}
